import React from 'react';
import { Form, Input, Button, Divider, Select, message } from 'antd'
// import { editPassword } from '@/request/api'
const { Option } = Select;

const selectAfter = (
    <Select defaultValue="天" className="select-after">
        <Option value="天">天</Option>
        <Option value="月">月</Option>
        <Option value="年">年</Option>
    </Select>
);
class qualityControlSet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleSubmit = () => {
        message.success("保存成功")
        // const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
        // this.props.form.validateFields((err, values) => {
        //     if (!err) {
        //         let param = {
        //             Type: 'ChangePassword',//修改   		
        //             USER_UID: userInfo.USER_UID, // 用户uid
        //             OLD_PASSWORD: values.oldPassword,//旧密码
        //             PASSWORD: values.loginpass, // 修改的密码
        //         }
        //         editPassword(param).then((res) => {
        //             if (res && res.Status === 1) {
        //                 if (res.Result === -1) {
        //                     message.error('原密码输入错误！');
        //                     return;
        //                 }
        //                 else {
        //                     message.success("保存成功")
        //                 }
        //             } else {
        //                 message.error("请检查网络连接");
        //             }
        //         })
        //     }
        // })
    }
    
    render() {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        return (
            <Form {...formItemLayout} className="formWrap">


                <Divider orientation="left">质控设置</Divider>
                <Form.Item label="百分比设置" style={{ width: '50%' }}>
                    {getFieldDecorator('oldPassword', {
                        rules: [{ message: '请输入正整数', pattern: /^[1-9]\d*$/ }]
                        })(
                            <Input autoComplete="off" suffix="%" />
                    )}
                </Form.Item>
                <Form.Item label="时间周期设置" style={{ width: '50%' }}>
                    <div style={{ marginBottom: 16 }}>
                    {getFieldDecorator('selectAfter', {
                        rules: [{ message: '请输入正整数', pattern: /^[1-9]\d*$/ }],
                        initialValue : '1'
                        })(
                            <Input addonAfter={selectAfter} />
                    )}
                       
                    </div>
                </Form.Item >

                <Form.Item wrapperCol={{ offset: 20 }}>
                    <Button type="primary" onClick={this.handleSubmit}>保存</Button>
                </Form.Item>
            </Form>
        );
    }
}

export default (Form.create({})(qualityControlSet));